<template>
  <div>
    <el-dialog
      title="标记"
      :visible.sync="dialogFormVisible"
      @close="close"
      width="500px"
      v-dialogDrag
    >
      <el-form
        :model="obj"
        :rules="rules"
        size="small"
        ref="ruleForm"
        label-position="right"
        label-width="20px"
      >
        <el-form-item prop="setKey">
          <el-radio-group v-model="obj.setKey">
            <el-radio label="isImportant">重要邮件</el-radio>
            <el-radio label="isTodo">待办邮件</el-radio>
            <el-radio label="isGarbage">垃圾邮件</el-radio>
            <el-radio label="isReply">无需回复</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="dialogFormVisible = false"
          v-preventReClick="5000"
          :disabled="disabled"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="checkEdit('ruleForm')"
          v-preventReClick="5000"
          :disabled="disabled"
          >确认</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 邮件标记弹窗组件（Amazon 版）
 * 功能：单选设置重要邮件/待办邮件/垃圾邮件/无需回复（无需回复 isReply 置 3，其余置 1），调用 updateStatus 接口保存
 */
import { updateStatus } from "@/api/user";
export default {
  name: "edit",
  props: {
    scope: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      // 表单校验规则：标记类型必选
      rules: {
        setKey: [
          { required: true, message: "请选择标记类型", trigger: "change" },
        ],
      },
      // 选中的标记类型（isImportant/isTodo/isGarbage/isReply）
      obj: {
        setKey: "",
      },
      // 提交数据：四类标记开关与邮件 id
      dataObj: {
        isImportant: "",
        isGarbage: "",
        isTodo: "",
        isReply: "",
        id: "",
      },
      // 按钮禁用状态（防止重复提交）
      disabled: false,
      // 弹窗显示状态
      dialogFormVisible: true,
    };
  },
  methods: {
    /** 关闭弹窗并通知父组件 */
    close() {
      this.$emit("isShowEdit");
    },
    /**
     * 校验并提交邮件标记
     * @param {String} formName 表单 ref 名称
     */
    checkEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.dataObj.id = this.scope.id;
          if (this.obj.setKey === "isReply") {
            this.dataObj["isReply"] = "3";
          } else {
            this.dataObj[this.obj.setKey] = "1";
          }
          updateStatus(this.dataObj).then((result) => {
            if (result.code == 200) {
              this.$message({
                message: result.msg,
                type: "success",
              });
              this.$emit("getList");
              this.$emit("isShowEdit");
            }
          });
        }
      });
    },
  },
};
</script>